export default __webpack_public_path__ + "static/media/gucci_x_mad_1.a776abf1.png";